import { BlockComponent } from './BlockComponent';
import { GameActionEvent } from '../../constants/GameActionEvent';

export class BlockWithToggleButtonComponent extends BlockComponent {
    #block;
    #name;
    #toggleButtons;
    #isOpened = false;
    #hasToggleModalControl;

    constructor(elem) {
        super(elem);
        this.#block = elem;
        this.#name = elem.dataset.extraScreen;
        this.#toggleButtons = Array.from(document.querySelectorAll(`[data-extra-screen-toggle="${this.#name}"]`));

        this.#hasToggleModalControl = !this.#toggleButtons.some((el) => (
            !el.hasAttribute('aria-controls') || !el.hasAttribute('aria-expanded')
        ));

        this._addListeners();
    }

    _addListeners() {
        super._addListeners();

        this.#toggleButtons.forEach((button) => {
            button.addEventListener('click', this.toggleOpen.bind(this));
        });
    }

    toggleOpen() {
        const t = Date.now();

        // To prevent double click
        if (this._clickTimestamp && t - this._clickTimestamp < 400) return;

        this._clickTimestamp = t;

        if (!this.#isOpened) {
            this.open();
        } else {
            this.close();
        }

        document.activeElement.blur();
    }

    open() {
        this.#isOpened = true;

        this.dispatchEvent({
            type: GameActionEvent,
            action: {
                type: `show-${this.#name}`
            }
        });

        this.#block.classList.add('active');

        if (this.#hasToggleModalControl) {
            this.#toggleButtons.forEach((el) => el.setAttribute('aria-expanded', true));
            this.#block.removeAttribute('hidden');
        }
    }

    close() {
        this.#isOpened = false;

        this.dispatchEvent({
            type: GameActionEvent,
            action: {
                type: `close-${this.#name}`
            }
        });

        this.#block.classList.remove('active');

        if (this.#hasToggleModalControl) {
            this.#toggleButtons.forEach((el) => el.setAttribute('aria-expanded', false));
            this.#block.setAttribute('hidden', '');
        }
    }
}
